import React from "react";
import logo from "../assets/LogoW.webp"
import { FaFacebook } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className=" bg-slate-900">
      <footer className="bg-gradient-to-r from-[#080710] via-[#140B1F] to-[#080710] text-white pt-12 pb-8 border-t border-white/10">
        <div className="max-w-6xl mx-auto  flex flex-col md:flex-row items-center justify-between gap-6 text-xs md:text-sm text-gray-300">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 rounded-md  py-1 shadow-lg shadow-black/40">
              <img
                src={logo}
                className="h-16 w-auto"
                alt="PixlyBooth"
              />
              {/* <span className="hidden sm:block text-[10px] font-semibold tracking-[0.25em] uppercase text-[#111]">
                Pixly Booth
              </span> */}
            </div>
            <span className="ml-2">
              © {new Date().getFullYear()} PixlyBooth. All rights reserved.
            </span>
          </div>

          <div className="flex items-center gap-4">
            <Link to='https://www.facebook.com/' className="text-center text-xl">
              <FaFacebook />
            </Link>
            <Link to='https://www.instagram.com/' className="text-center text-xl">
              <FaSquareInstagram />
            </Link>
            <Link to='https://www.linkedin.com/' className="text-center text-xl">
              <FaLinkedin />
            </Link>
            <Link to='https://x.com/' className="text-center text-xl">
              <FaSquareXTwitter />
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

